export const ADMIN_USER_TYPES = [1, 2];

// export const isAdminUser = (userType) => {
//   return ADMIN_USER_TYPES.includes(Number(userType));
// };
export const isAdminUser  = (userType) => {
  const type = Number(userType);

  return ADMIN_USER_TYPES.includes(type) ? type : null;
};